import { ITrackerEvent } from '../models/ITrackerEvent';

type EventFactory<P extends object = undefined> = P extends undefined
  ? () => ITrackerEvent<undefined>
  : (props: P) => ITrackerEvent<P>;

export function createEvent<P extends object = undefined>(
  name: string
): EventFactory<P> {
  return ((props: P) => ({
    event: name,
    props
  })) as EventFactory<P>;
}
